
import { Component, Vue } from "vue-property-decorator";
import FormEtablissement from "@/components/etablissement/FormEtablissement.vue";
import { rulesForms } from "@/core/RulesForm";
import { Action } from "@/core/CommonDefinition";

@Component({
  components: { FormEtablissement }
})
export default class FormFusionEtablissement extends Vue {
  sirenEtab: Array<string> = ["", ""];
  sirenNumber: number = 2;
  rulesForms: any = rulesForms;
  Action: any = Action;

  increaseSirenNumber() {
    this.sirenNumber++;
  }

  decreaseSirenNumber() {
    if (this.sirenNumber > 2) {
      this.sirenNumber--;
      this.sirenEtab.pop();
    }
  }
}
